module.exports = "<div class=\"wrapper\" [ngStyle]=\"styles\">\n  <ng-content select=\"[card-body]\"></ng-content>\n</div>\n"